import React from "react";
import path from '../../../img/partners/exante.png'

const Exante: React.FunctionComponent = () => (
  <img src={path}/>
)

export default Exante
